import { toTranslateAudoVideoFormats } from "./toTranslateAudoVideoFormats";

export const getAudioFormats = t => {
  const audioElement = document.createElement("audio");

  const formatsToCheck = [
    "audio/aac",
    "audio/flac",
    "audio/mpeg",
    'audio/ogg; codecs="flac"',
    'audio/ogg; codecs="vorbis"',
    'audio/ogg; codecs="opus"',
    'audio/wav; codecs="1"',
    'audio/webm; codecs="vorbis"',
    'audio/webm; codecs="opus"',
    'audio/mp4; codecs="mp4a_40_2"',
  ];

  const audioFormats = formatsToCheck.map(format => ({
    id: format,
    description:
      toTranslateAudoVideoFormats(audioElement.canPlayType(format), t) ||
      t("global.notSupported"),
  }));

  return { audioFormats };
};
